export function calculate(amount, termMonths = 60, apr = 6.9, deposit = 0) {
    const monthlyInterestRate = Math.pow(apr / 100 + 1, 1 / 12) - 1;
    const pmt = monthlyInterestRate + monthlyInterestRate / (Math.pow(1 + monthlyInterestRate, termMonths) - 1);
    const netAmount = amount - deposit;

    const monthlyRepayment = Math.round(netAmount * pmt * 100) / 100;
    const totalPayment = Math.round(monthlyRepayment * termMonths * 100) / 100;
    const creditCost = Math.round((totalPayment - netAmount) * 100) / 100;

    return {
        amount: formatMoney(netAmount),
        term: termMonths,
        apr: apr,
        deposit: formatMoney(deposit),
        monthlyRepayment: formatMoney(monthlyRepayment),
        totalRepayable: formatMoney(totalPayment),
        costOfCredit: formatMoney(creditCost),
    };
}

export function creditScoreRatingToApr(creditScore) {
    switch (creditScore) {
        case "Excellent":
            return 9.9;
        case "Good":
            return 11.9;
        case "Fair":
            return 16.9;
        case "Poor":
            return 22.9;
        case "Bad":
            return 28.9;
        default:
            return 9.9;
    }
}

function formatMoney(amount) {
    return new Intl.NumberFormat("en-GB", {style: "currency", currency: "GBP"}).format(amount);
}

window.addEventListener("DOMContentLoaded", function () {
    const fc = document.querySelector("#car-finance-calculator");

    if (!fc) return;

    const sliders = fc.querySelectorAll("input[type=range]");

    sliders.forEach((slider) => {
        const min = slider.getAttribute("min");
        const max = slider.getAttribute("max");
        const currentValue = slider.getAttribute("value");

        slider.addEventListener("input", function (e) {
            const value = e.target.value;
            slider.style.backgroundSize = `${((value - min) * 100) / (max - min)}% 100%`;
        });

        slider.style.backgroundSize = `${((currentValue - min) * 100) / (max - min)}% 100%`;
    });

    const formatter = new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    const creditScoreSelect = fc.querySelector("select[name='credit-rating']");
    const inputAmount = fc.querySelector("#range-slider-amount");
    const inputTerm = fc.querySelector("#range-slider-term");
    const outputLoanAmountFormatted = fc.querySelector("#outputLoanAmountFormatted");
    const outputLoanDuration = fc.querySelector("#outputLoanDuration");
    const monthlyRepayment = fc.querySelector(".js-monthly-repayment");
    const exampleTerm = fc.querySelector(".exampleTerm");
    const exampleApr = fc.querySelector(".exampleApr");
    const exampleTotalAmount = fc.querySelector(".exampleTotalAmount");
    const exampleCostOfCredit = fc.querySelector(".exampleCostOfCredit");

    inputAmount.addEventListener("input", (e) => {
        outputLoanAmountFormatted.value = formatter.format(e.currentTarget.value);
        calculateMonthlyRepayment();
    });

    inputTerm.addEventListener("input", (e) => {
        outputLoanDuration.value = e.currentTarget.value;
        calculateMonthlyRepayment();
    });

    creditScoreSelect.addEventListener("change", (e) => {
        calculateMonthlyRepayment();
    });

    function calculateMonthlyRepayment() {
        const creditRating = fc.querySelector("select[name='credit-rating']");
        const apr = creditScoreRatingToApr(creditRating.value);
        const result = calculate(inputAmount.value, +inputTerm.value * 12, apr);

        monthlyRepayment.textContent = result.monthlyRepayment;
        exampleTerm.textContent = outputLoanDuration.value * 12;
        exampleApr.textContent = result.apr;
        exampleCostOfCredit.textContent = result.costOfCredit;
        exampleTotalAmount.textContent = result.totalRepayable;
    }

    calculateMonthlyRepayment();
});
